var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.9157 2.82551C24.9523 3.25165 23.9307 3.53151 22.8846 3.65584C23.9863 2.99604 24.8106 1.95825 25.204 0.735794C24.1692 1.3516 23.0348 1.78317 21.8536 2.01663C21.0594 1.16683 20.0067 0.603247 18.8591 0.413484C17.7115 0.223721 16.5334 0.418413 15.5078 0.967294C14.4823 1.51617 13.6669 2.38849 13.1883 3.44863C12.7097 4.50876 12.5947 5.69733 12.8613 6.82953C10.7627 6.72453 8.70959 6.17931 6.83537 5.22926C4.96116 4.27922 3.30772 2.9456 1.98242 1.31501C1.51335 2.12067 1.26686 3.03653 1.26818 3.96879C1.26818 5.79856 2.20072 7.41506 3.61532 8.36148C2.77743 8.33506 1.95799 8.10878 1.22527 7.70151V7.76586C1.22523 8.9847 1.64679 10.166 2.41844 11.1095C3.1901 12.053 4.26433 12.7005 5.45896 12.9422C4.68118 13.1532 3.86555 13.1843 3.07396 13.0331C3.41079 14.0822 4.06735 14.9997 4.95167 15.6571C5.836 16.3144 6.90379 16.6787 8.00549 16.6989C6.9106 17.5588 5.65694 18.1945 4.31619 18.5695C2.97545 18.9445 1.57392 19.0516 0.191772 18.8845C2.60418 20.4359 5.4124 21.2595 8.28058 21.2569C17.9897 21.2569 23.2972 13.2148 23.2972 6.24022C23.2972 6.01308 23.2922 5.78341 23.2821 5.55753C24.3149 4.81094 25.2062 3.88622 25.9144 2.82677L25.9157 2.82551Z",
    fill: "#C7D0CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.c9c08ef38d65de6c214769868a5033de.svg";
export { ForwardRef as ReactComponent };